// Colors for full series analysis mode
export const ANALYSIS_COLORS = {
    bid: '#26A69A',
    ask: '#EF5350',
    fairValue: '#212121',
    uncertaintyBand: 'rgba(158, 158, 158, 0.2)',
    buyTrade: '#2196F3',
    sellTrade: '#F44336',
    candleUp: '#4CAF50',
    candleDown: '#F44336',
    // Aliases for SeriesToggleControls compatibility
    trades: '#2196F3',
    candles: '#4CAF50',
} as const;

// Colors for volume panel
export const VOLUME_COLORS = {
    volumeUp: 'rgba(76, 175, 80, 0.6)',
    volumeDown: 'rgba(244, 67, 54, 0.6)',
    volumeNeutral: 'rgba(158, 158, 158, 0.5)',
} as const;

// Layout constants
export const LAYOUT = {
    VOLUME_PANEL_RATIO: 0.2,
    VOLUME_GAP: 15,
    DEFAULT_MARGIN: { top: 20, right: 50, bottom: 40, left: 50 },
    SVG_HEIGHT_WITH_VOLUME: 480,
    SVG_HEIGHT_WITHOUT_VOLUME: 400,
} as const;

// Scale constants
export const SCALE = {
    DECIMAL_MAX: 1,
    DECIMAL_MIN: 0.01,
    PERCENT_MAX: 100,
    PERCENT_MIN: 1,
    LOG_TICK_VALUES_DECIMAL: [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 0.8, 1],
    LOG_TICK_VALUES_PERCENT: [1, 2, 5, 10, 20, 50, 80, 100],
} as const;
